module.exports = "/_next/static/images/penfold-banner-lg-947ae6c61f426e862a85bad3844bc9a6.png";